// angular packages
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// third-party packages
import { DialogModule } from '@progress/kendo-angular-dialog';
import { IntlModule, NumberPipe } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PagerModule } from '@progress/kendo-angular-pager';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

// internal
import { ClCommonAngularModule } from 'cl-common-angular';
import { AnonymousRoutingModule } from './anonymous-routing.module';
import { CreateAccountComponent } from './create-account.component';
import { EqualValidator } from '../shared/directives/equal-validator.directive';

import { SharedModule } from '../shared/shared.module';
import { CampaignComponent } from './campaign.component';
import { GalleryComponent } from './gallery.component';
import { CampaignLayoutOneComponent } from './campaign-layout-one.component';
import { CampaignLayoutTwoComponent } from './campaign-layout-two.component';
import { CampaignLayoutThreeComponent } from './campaign-layout-three.component';
import { GiftCheckoutModalComponent } from './gift-checkout-modal.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { LabelModule } from '@progress/kendo-angular-label';
import { MakePaymentModalComponent } from './make-payment-modal.component';
import { TermsAndConditionsComponent } from './termsandconditions.component';

@NgModule({
    declarations: [
        CampaignComponent,
        CampaignLayoutOneComponent,
        CampaignLayoutTwoComponent,
        CampaignLayoutThreeComponent,
        GalleryComponent,
        CreateAccountComponent,
        EqualValidator,
        GiftCheckoutModalComponent,
        MakePaymentModalComponent,
        TermsAndConditionsComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        LayoutModule,
        ClCommonAngularModule,
        CommonModule,
        AnonymousRoutingModule,
        DateInputsModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        DialogModule,
        IntlModule,
        PagerModule,
        DropDownsModule,
        LabelModule

    ],
    providers: [NumberPipe]
})
export class AnonymousModule { }
